const endpoint = {
  login: "/auth/login",
  logout: "/auth/logout",
  forgot_password: "/auth/forgot-password",
  update_profile: "/auth/update",
  reset_password: "/auth/reset-password",
  create_password: "/auth/set-password",
  me: "/auth/me",
  get_user: "/auth/admin/users",
  add_user: "/auth/admin/create-user",
  update_user: "/auth/admin/users",
  update_user_profile: "/auth/update",
  attachment: "/attachment",
  get_blogs: "/blog/list",
  get_blog_category: "/blog-category/list",
  get_blog_tag: "/tag/list",
  add_blog: "/blog/create",
  update_blog: "/blog/update",
  get_blog: "/blog/get",
  delete_blog: "/blog/delete",
  create_blog_category: "/blog-category/create",
  get_public_blogs: "/blog/public/list?page=1&limit=-1",
  get_cms_pages_list: "/cms/list",
  get_cms_single_page_slug: "/cms/public",
  get_cms_single_page_id: "/cms/get",
  update_cms_single_page : "/cms/update/id",
  // CMS Approval Endpoints
  get_cms_pending_approvals: "/cms/pending-approvals",
  get_cms_change_diff: "/cms/change-diff",
  approve_cms_changes: "/cms/approve",
  reject_cms_changes: "/cms/reject",
  // Role Management Endpoints
  get_roles: "/role/list",
  get_role: "/role",
  add_role: "/role/create",
  update_role: "/role/update",
  delete_role: "/role/delete",
  get_permissions: "/permission/list",
  get_permissions_by_module: "/permission/module",
  get_available_modules: "/permission/modules",
  add_permission: "/permission/create",
  update_permission: "/permission/update",
  delete_permission: "/permission/delete",
  // Activity Logs Endpoints
  get_activity_logs: "/activity-logs",
  get_entity_activity_logs: "/activity-logs/entity",
  get_user_activity_summary: "/activity-logs/user",
  get_my_activity_logs: "/activity-logs/my-logs",
  cleanup_old_logs: "/activity-logs/cleanup",
};

export default endpoint;
